module.exports = __webpack_public_path__ + "img/mic.c18d4034.svg";